import { render, staticRenderFns } from "./linkManagement.vue?vue&type=template&id=2a28c5fe&scoped=true"
import script from "./linkManagement.vue?vue&type=script&lang=js"
export * from "./linkManagement.vue?vue&type=script&lang=js"
import style0 from "./linkManagement.vue?vue&type=style&index=0&id=2a28c5fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28c5fe",
  null
  
)

export default component.exports